module.exports = __webpack_public_path__ + "static/media/add.5c53cdd9.svg";